export default __webpack_public_path__ + "static/media/s4.ecd73a88.svg";